import Breadcrumbs from "./Breadcrumbs";
import RelatedTopics from "./RelatedTopics";
import TopicSidebar from "./TopicSidebar";
import "../style/articleLayout.css";

export default function ArticleLayout({ config, currentPath, children }) {
  if (!config) {
    return children;
  }

  return (
    <div className="article-layout-page">
      <div className="article-layout-container">
        <Breadcrumbs items={config.breadcrumbs} />

        <header className="article-layout-header">
          <span>{config.eyebrow}</span>
          <h1>{config.title}</h1>
          <p>{config.description}</p>
        </header>

        <div className="article-layout-grid">
          <div className="article-layout-content">{children}</div>
          <TopicSidebar
            toc={config.toc}
            ctas={config.ctas}
            previous={config.previous}
            next={config.next}
          />
        </div>

        <RelatedTopics topics={config.related} currentPath={currentPath} />
      </div>
    </div>
  );
}
